// Generated by CoffeeScript 2.7.0
require('../concerns/controller_register.js');

require('../share/exportable_files.js');

require('./sessions.js');

require('./comments.js');

require('./style_guides.js');

require('./messages/index.js');

require('./yet_another_workflow/index.js');

require('./dataclip/index.js');

require('./members/index.js');

require('./settings/index.js');

require('./organizations/index.js');

require('./users/index.js');

require('./organization_profile/index.js');

require('./tag_groups/index.js');

require('./access/index.js');

require('./user_profile/index.js');

require('./push_package/index.js');

require('./cascaded_selects/index.js');

require('./namespaces/index.js');

require('./categories/index.js');

require('./templates/index.js');

require('./cms/snippets/index.js');

require('./message_exception_templates/index.js');

require('./menus.js');
